import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

function PieAndDoughnutChart() {
  const data = {
    labels: ['Desktop', 'Mobile', 'Tablet', 'Other'], // إضافة فئة جديدة
    datasets: [
      {
        label: 'Device Usage',
        data: [1200, 450, 300, 200], // إضافة بيانات للفئة الجديدة
        backgroundColor: ['#646465', '#b1e3ff', '#a1e3cb', '#a2bed2'], // إضافة لون جديد للفئة
        borderColor: '#fff',
        borderWidth: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  return (
    <div>
      <div style={{ width: '150px' }}>
        <Doughnut data={data}  options={options} />
      </div>
    </div>
  );
}

export default PieAndDoughnutChart;
